import { Card, CardContent, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import CustomMonthYearPicker from './CustomMonthYearPicker'
import Loader from './Loader'
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#F5F8FF',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '12px',
    margin: '0px 10px 0px 10px',
  },
  subtitle: {
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    lineHeight: ' 38px',
    fontStyle: 'normal',
  },
  margin: {
    margin: '20px 10px 0px 10px',
  },
}))
export default function CardWithData({ heading, label, margin, children, productiveDate, setProductiveDate }) {
  const classes = useStyles()
  return (
    <Card variant="outlined" className={margin ? `${classes.root} ${classes.margin}` : classes.root}>
      <CardContent>
        {!children ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ display: 'flex' }}>
              <p style={{ fontSize: '14px', fontWeight: 600 }}> {heading} </p>
              {heading === 'Productive Hourss' && (
                <span style={{ marginLeft: '10px' }}>
                  <CustomMonthYearPicker value={productiveDate} handleChange={setProductiveDate} />
                </span>
              )}
            </div>
            <br />

            <Typography className={classes.subtitle}>{label === 0 || label ? label : <Loader />}</Typography>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              // alignItems: 'center',
            }}
          >
            <p style={{ fontSize: '14px', fontWeight: 600 }}> {heading} </p>
            {children}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
